<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2019-12-16
 * @LastEditors: WUFAN
 * @LastEditTime: 2019-12-16
 -->
<template>
  <div class="">
    <h4 class="login-title">{{account}}</h4>
    <el-form class="login-form"
            status-icon
            label-width="0">
        <el-form-item v-if="selectType.needPicCaptchaBeforeSend">
          <el-input v-model="captcha" placeholder="请输入图片码">
            <div class="append" slot="append">
              <img :src="captchaUrl" @click="generateCaptcha" />
            </div>
          </el-input>
        </el-form-item>
        <el-form-item>
            <el-button
            :disabled="count > 0"
            type="primary"
                        size="small"
                        @click.stop.prevent="didTapToNext"
                        :loading="submitLoading"
                        class="login-submit">{{ count ? `已发送${count}`: '发送验证码' }}</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  name: 'AccountInput',
  props: {
    userInfo: {
      type: Object
    },
    retrievePasswordType: {
      type: String
    },
    selectType: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      passwordVerifyList: [],
      'submitLoading': false,
      account: '',
      captcha: '',
      captchaUrl: null,
      count: 0
    }
  },

  components: {},

  mounted: function() {
    for (let item in this.userInfo) {
      if (item === this.retrievePasswordType) {
        this.account = this.userInfo[item]
      }
    }
    this.generateCaptcha()

    if (Cookies.get('captchaTime')) {
      this.setCookieDate()
    }
  },
  methods: {
    generateCaptcha() {
      if (this.selectType.needPicCaptchaBeforeSend) {
        this.$downloadFile.get('/self/retrieve-password/generate-pic-captcha', { params: {
          accountId: this.userInfo.id,
          retrievePasswordType: this.retrievePasswordType
        }}).then(response => {
          this.captchaUrl = response.data.url
        }).catch(error => {
          this.$message.error('验证码获取失败,' + error.msg)
        })
      }
    },
    setCount() {
      let i = setInterval(() => {
        if (!this.count) {
          clearInterval(i)
        }
        if (this.count) { this.count -= 1 }
      }, 1000)
    },
    setCookieDate() {
      const date = new Date()
      const val = this.selectType.sendTimeIntervalInMills / 1000
      date.setTime(date.getTime() + (this.selectType.sendTimeIntervalInMills))
      Cookies.set('captchaTime', val, { expires: date })
      this.count = val
      this.setCount()
    },
    didTapToNext: function() {
      const loading = this.$loading({
        lock: true,
        text: '加载中..',
        spinner: 'fa fa-spinner fa-5x',
        background: 'rgba(0, 0, 0, 0.3)',
        target: '.sub-main',
        body: true
      })

      const params = {
        accountId: this.userInfo.id,
        retrievePasswordType: this.retrievePasswordType
      }

      if (this.selectType.needPicCaptchaBeforeSend) {
        params.picCaptchaInput = this.captcha
      }

      this.setCookieDate()
      this.$http.post('/self/retrieve-password/send-captcha', null, { params }).then(response => {
        loading.close()
        /** 跳转密码验证 */
        this.$message.success('验证码发送成功')
        var childrenInfo = {}
        childrenInfo.status = 2 // 注入下一步状态
        this.$emit('fatherMethod', childrenInfo)
      }).catch(error => {
        this.count = 0
        loading.close()
        this.$message.error(error.msg)
      })
    }
  }
}

</script>
<style lang='scss'>
.login-form {
  .el-input-group__append {
    padding: 0!important;
    background-color: transparent;
    border: 0;
    img {
      width: 110px;
      cursor: pointer;
    }
  }
}

</style>
